/**
 * useFormat Composable
 * Handles all formatting utilities for Tax Dashboard
 */

/**
 * Format numbers with locale string
 * @param {number} num - Number to format
 * @returns {string} Formatted number (e.g., 1000 -> "1,000")
 */
export const formatNumber = (num) => {
  return num?.toLocaleString('en-US') || '0';
};

/**
 * Normalize any incoming date to yyyy-MM-dd format
 * @param {string|Date} d - Date to format
 * @returns {string|null} Date in yyyy-MM-dd format
 */
export const formatStateDate = (d) => {
  if (!d) return null;
  const dt = typeof d === 'string' ? new Date(d) : d instanceof Date ? d : new Date(d);
  if (Number.isNaN(dt.getTime())) return null;
  const yyyy = dt.getFullYear();
  const mm = String(dt.getMonth() + 1).padStart(2, '0');
  const dd = String(dt.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

/**
 * Format date string to DD/MM/YYYY display format
 * @param {string} dateString - Date string to format
 * @returns {string} Date in DD/MM/YYYY format
 */
export const formatDisplayDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-GB'); // DD/MM/YYYY format
};

/**
 * Get today's date in yyyy-MM-dd format
 * @returns {string} Current date in yyyy-MM-dd format
 */
export const getTodayDate = () => {
  const today = new Date();
  const dd = String(today.getDate()).padStart(2, '0');
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const yyyy = today.getFullYear();
  return `${yyyy}-${mm}-${dd}`;
};

/**
 * useFormat Composable
 * @returns {Object} Formatting functions
 */
export function useFormat() {
  return {
    formatNumber,
    formatStateDate,
    formatDisplayDate,
    getTodayDate
  };
}
